<template>
  <div :class="$b()">
    <InvestPreregistrationForm
      v-if="formId === 'invest-preregistration'"
    />
  </div>
</template>

<script>
export default {
  name: 'FormBlock',
  props: {
    formId: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="postcss">

</style>